import { combineReducers } from 'redux';
import { initialState } from '../initialState';
import { reducerFactory } from './reducerFactory';

import { mainHandler } from './mainHandler';

export default combineReducers({ main: reducerFactory(initialState, mainHandler) });
